import warningLogo from "@assets/svgs/warning.svg";

const WarningScreen = () => {
  return (
    <>
      <div className="flex justify-center items-center h-screen flex-col bg-wht">
        <img src={warningLogo} alt="warning-logo" />
        <p className="text-[22px] font-semibold text-black pt-[62px] ">
          Please use landscape mode to view.
        </p>
      </div>
    </>
  );
};

export default WarningScreen;
